import React from 'react';
import styled from 'styled-components';
import { BodyThree } from '../../../../../styles/theme/default/typography';

const Wrapper = styled.li`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

function MenuItem({ name, onClick, color }) {
  return (
    <Wrapper onClick={onClick}>
      <BodyThree color={color ? '#A83569' : ''} className="body-two">
        {name}
      </BodyThree>
      <div className="arrow">
        <img
          src="https://theinside.imgix.net/icons/right-arrow.svg"
          alt="arrow"
        />
      </div>
    </Wrapper>
  );
}

export default MenuItem;
